<template>
  <component
  :is="wrapperTag"
  :href="!disabled ? href : undefined"
  :to="!disabled ? to : undefined"
  :class="['tech_primary_icon', { 'icon--disabled': disabled }]"
  @click.prevent="disabled && $event.stopImmediatePropagation()"
  >
  <v-img
  v-if="isImage"
  :src="resolvedSrc"
  :width="size"
  :height="size"
  :alt="alt"
  :class="border ? 'border-sm' : 'border-0'"
  :style="{ opacity: disabled ? 0.5 : 1, pointerEvents: disabled ? 'none' : 'auto' }"
  rounded="circle"
  />
  <v-icon
  v-else
  :icon="icon"
  :color="color"
  :size="size"
  :class="border ? 'border-sm' : 'border-0'"
  :style="{ opacity: disabled ? 0.5 : 1, pointerEvents: disabled ? 'none' : 'auto' }"
  />
</component>
</template>

<script lang="ts" setup>
import { computed, watchEffect } from 'vue'

// Dynamically import all assets once
const assetMap = import.meta.glob('/src/assets/**/*', { eager: true, as: 'url' }) as Record<string, string>

const props = defineProps<{
  icon: string
  size?: string | number
  color?: string
  alt: string
  href?: string
  to?: string
  disabled?: boolean
  border: boolean // ✅ required border prop
}>()

watchEffect(() => {
  if (!props.alt || props.alt.trim() === '') {
    console.error('[Icon Component] Missing required "alt" prop.')
  }
})

const isImage = computed(() =>
props.icon.endsWith('.svg') ||
props.icon.endsWith('.png') ||
props.icon.endsWith('.jpg') ||
props.icon.startsWith('http') ||
props.icon.startsWith('@/assets/')
)

// Universal resolver — works in both dev & prod
const resolvedSrc = computed(() => {
  if (props.icon.startsWith('@/')) {
    const key = props.icon.replace('@', '/src')
    return assetMap[key] ?? props.icon
  }
  return props.icon
})

const wrapperTag = computed(() => {
  if (props.to) return 'router-link'
  if (props.href) return 'a'
  return 'div'
})
</script>

<style lang="scss">

// Styles for the Icon component
.tech_primary_icon {
  
  .v-img {
    border-color: rgb(var(--v-theme-primary-800)) !important;
  }
  
  // Set disabled styles for the icon wrapper
  .icon--disabled {
    cursor: not-allowed;
    pointer-events: none;
  }
  
}
</style>